module.exports = __webpack_public_path__ + "static/jc04657-preparation-storage-bag-d65e3ad1be8e430c3ff59f79f4aab012.png";